import { toast } from "react-toastify";
import defaultErrorHandler from "actions/global/default-error-handler";
import {
  requestTariffGetList,
  requestTariffAdd,
  requestTariffGetTypes
} from "actions/tariff/requests";

import {
  TARIFF_LOADING,
  TARIFF_ERROR,
  TARIFF_GET_LIST,
  TARIFF_RESET_LIST,
  TARIFF_ADD,
  TARIFF_GET_TYPES
} from "actions/tariff/constants";

export const setLoading = (status) => ({
  type: TARIFF_LOADING,
  payload: status
});

export const tariffGetList = () => dispatch => {
  dispatch(setLoading(true));
  requestTariffGetList()
    .then(response => {
      dispatch({
        type: TARIFF_GET_LIST,
        payload: response.data
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, TARIFF_ERROR));
    });
};

export const actionResetList = () => dispatch => {
  dispatch({
    type: TARIFF_RESET_LIST
  });
};

export const tariffAdd = (data) => dispatch => {
  dispatch(setLoading(true));
  requestTariffAdd(data)
    .then(response => {
      dispatch({
        type: TARIFF_ADD,
        payload: response.data
      });
      toast("Tariff updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, TARIFF_ERROR));
    });
};

export const tariffGetTypes = () => dispatch => {
  dispatch(setLoading(true));
  requestTariffGetTypes()
    .then(response => {
      dispatch({
        type: TARIFF_GET_TYPES,
        payload: response.data.content
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, TARIFF_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/tariff/actions.js